import { z } from 'zod';
/**
 * Admin Scadenze — risposta GET /api/v1/admin/scadenze.
 *
 * `dataScadenza` è calcolata lato API da `dataStipula + durataMesi` estratti
 * dal JSONB `datiStrutturati`. `giorniAllaScadenza` è positivo se la
 * scadenza è futura, negativo se già trascorsa.
 */
export const ScadenzaItemSchema = z.object({
    praticaId: z.string(),
    accountId: z.string(),
    tipologia: z.string(),
    stato: z.string(),
    dataStipula: z.string().datetime(),
    durataMesi: z.number().int().positive(),
    dataScadenza: z.string().datetime(),
    giorniAllaScadenza: z.number().int(),
});
export const ScadenzeResponseSchema = z.object({
    items: z.array(ScadenzaItemSchema),
    totale: z.number().int().nonnegative(),
});
export const ScadenzeQuerySchema = z.object({
    filter: z.enum(['upcoming', 'past', 'all']).default('all'),
});
//# sourceMappingURL=admin.js.map